import { getConfigValue } from '../config';
import { getAuthToken } from './auth';
import { getLocale } from './locale';

const api = {
    fetchData(objectName) {
        const BASE_URL = getConfigValue('MathleticsLibraryGatewayUrl');
        const getBooksApiUrl = `${BASE_URL}/api/${objectName}`;
        return getAuthToken()
            .then(authToken => fetch(getBooksApiUrl, {
                headers: {
                    AuthToken: authToken,
                    Locale: getLocale() || 'en'
                }
            }))
            .then(data => data.json());
    }
};

export default api;
